import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { interval, Subscription, switchMap } from 'rxjs';
import { AppConfig } from '../config/app.config';
import { AuthService } from '../auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class PeriodicAPICallService {

  private periodicSubscription: Subscription | null = null;
    private Url = AppConfig.apiUrl;
    authService = inject(AuthService);
  constructor(private http: HttpClient) {}


  startPeriodicApiCall() {
    if (this.periodicSubscription) return;
    const storageData = this.authService.getUserDetailsFromStorage();
    const userId = storageData?.userDetails?.userId;
    const sessionId = Number(sessionStorage.getItem('sessionId'));
    const userLATInterval = Number(sessionStorage.getItem('userLATInterval'));
    const path = `api/UserMaster/UpdateLastActivitySession?userId=${userId}&userSessionId=${sessionId}`
    const encodedPath = encodeURIComponent(path);
    this.periodicSubscription = interval(userLATInterval * 1000).pipe( 
      switchMap(() => {
        return this.http.post(`${this.Url}/Proxy?path=${encodedPath}`,{})
      })
    ).subscribe({
      next: (res) => {},
      error: (err) =>{}
    });
}


  stopPeriodicApiCall() {
    if (this.periodicSubscription) {
      this.periodicSubscription.unsubscribe();
      this.periodicSubscription = null;
    }
  }
}
